import { render, staticRenderFns } from "./ModalVisualizaEstrutura.vue?vue&type=template&id=591f8c16"
import script from "./ModalVisualizaEstrutura.vue?vue&type=script&lang=js"
export * from "./ModalVisualizaEstrutura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports